// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';

import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { FlashbarProps } from './interfaces';
import { InternalFlashbar } from './internal';

export { FlashbarProps };

export default function Flashbar(props: FlashbarProps) {
  const { __internalRootRef } = useBaseComponent('Flashbar', {
    props: { stackItems: props.stackItems },
    metadata: {
      itemsWithPersistence: props.items?.filter(item => !!item.persistenceConfig?.uniqueKey).length ?? null,
      itemsWithCrossServicePersistence:
        props.items?.filter(item => !!item.persistenceConfig?.crossServicePersistence).length ?? null,
    },
  });
  return <InternalFlashbar __internalRootRef={__internalRootRef} {...props} />;
}

applyDisplayName(Flashbar, 'Flashbar');



// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/src/flashbar/index.tsx